/* eslint-disable no-unused-vars */
import { checkAllTokens, logout } from "@/models/User.js";

const checkToken = {
    data() {
        return {
            flag: true,
            interval: undefined,
            time: 180000
        };
    },
    watch: {
        $route(to, from) {
            this.check();
        }
    },
    mounted() {
        this.createInterval();
    },
    methods: {
        async check() {
            this.flag = false;
            let isValid = await checkAllTokens();
            if (!isValid) logout();
            this.flag = true;
        },
        createInterval() {
            this.interval = setInterval(() => {
                if (this.flag) this.check();
            }, this.time);
        },
        destroyInterval() {
            if (this.interval) clearInterval(this.interval);
        }
    },
    beforeDestroy() {
        this.destroyInterval();
    }
};

export default checkToken;
